export default __webpack_public_path__ + "static/media/fv_banner_sp.8af4dcfa.jpg";